export default __webpack_public_path__ + "static/B0307-8184be02eed363b16975c15606e18739.png";